import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const SortUp = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M27.5 6C27.7803 6 28.0477 6.11765 28.2372 6.32428L33.7372 12.3243C34.1104 12.7314 34.0828 13.364 33.6757 13.7372C33.2686 14.1103 32.636 14.0828 32.2629 13.6757L28.5 9.5708V33C28.5 33.5523 28.0523 34 27.5 34C26.9477 34 26.5 33.5523 26.5 33V9.5708L22.7372 13.6757C22.364 14.0828 21.7314 14.1103 21.3243 13.7372C20.9172 13.364 20.8897 12.7314 21.2629 12.3243L26.7629 6.32428C26.9523 6.11765 27.2197 6 27.5 6Z"
                fill={props.color ? props.color : "white"} />
            <path opacity="0.3" fillRule="evenodd" clipRule="evenodd"
                d="M12.5 6C13.0523 6 13.5 6.44772 13.5 7L13.5 30.4292L17.2629 26.3243C17.636 25.9172 18.2686 25.8897 18.6757 26.2628C19.0828 26.636 19.1104 27.2686 18.7372 27.6757L13.2372 33.6757C13.0477 33.8824 12.7803 34 12.5 34C12.2197 34 11.9523 33.8824 11.7629 33.6757L6.26285 27.6757C5.88966 27.2686 5.91716 26.636 6.32428 26.2628C6.7314 25.8897 7.36397 25.9172 7.73716 26.3243L11.5 30.4292L11.5 7C11.5 6.44772 11.9477 6 12.5 6Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default SortUp;
